import { AxiosError } from 'axios'

// In built environments the app is served from the same origin as the API,
// while locally everything goes through the Vite dev proxy (see vite.config.ts)
export const getBaseUrl = () =>
  import.meta.env.PROD &&
  (import.meta.env.MODE === 'production' || import.meta.env.MODE === 'stage' || import.meta.env.MODE === 'development')
    ? `${window.location.origin}/api`
    : import.meta.env.AXIOS_DEV_BASE_URL

export const isAxiosError = (err: unknown): err is AxiosError<unknown> => err instanceof AxiosError

export function getErrorMessage(err: unknown, fallback = 'Something went wrong, please try again.') {
  if (!isAxiosError(err)) return fallback

  const data = err.response?.data

  if (data && typeof data === 'object' && 'message' in data && typeof data.message === 'string') return data.message

  return err.message || fallback
}
